import {Component} from '@angular/core';
import {MatProgressSpinner} from '@angular/material/progress-spinner';

@Component({
  selector: 'app-global-loading-overlay',
  imports: [
    MatProgressSpinner
  ],
  template: '<mat-spinner></mat-spinner>',
  styles: [':host { display: block; }']
})
export class GlobalLoadingOverlayComponent {}
